<template>
  <ul>
    <li v-for="education in educationContent" :key="education.id">
      <div class="icon">
        <i class="fa fa-briefcase"></i>
      </div>
      <span class="time open-sans-font text-uppercase">{{
        education.year
      }}</span>
      <h5 class="poppins-font text-uppercase">
        {{ education.degree }}
        <span class="place open-sans-font">{{ education.institute }}</span>
      </h5>
      <p class="open-sans-font">{{ education.details }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      educationContent: [
        {
          id: 1,
          year: "2010 - 2012",
          degree: "Studia drugiego stopnia z tytułem inżynier magister",
          institute: "Uniwersytet Zielono Górski",
          details: `Kierunek informatyka, specjalizacja Inżynieria oprogramowaniat`,
        },
        {
          id: 2,
          year: "2007 - 2010",
          degree: "Studia pierwszego stopnia z tytułem inżyniera",
          institute: "Uniwersytet Zielono Górski",
          details: `Kierunek informatyka, specjalizacja Inżynieria oprogramowania`,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
